import styled from 'styled-components';
import SanitizedIndoorsSvg from '../../../assets/onboardingNew/homepage/sanitized-indoors.svg';

const SanitizedIndoorsNewIcon = styled(SanitizedIndoorsSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.4rem'};
height: ${props => props.height || '3.2rem'};
display: flex;
`;

export default SanitizedIndoorsNewIcon;
